<template>
    <VApp>
        <VMain>
            <router-view />
        </VMain>
    </VApp>
</template>

<script setup>
import { VApp, VMain } from 'vuetify/components'
import { useSupportUnread } from '@/composables/useSupportUnread'

// Глобальный bootstrap счётчика непрочитанных тикетов поддержки.
//
// Подписка живёт на уровне App.vue, поэтому красный бейдж «1» и
// browser-push приходят даже если пользователь не в `ChatPage`. Внутри
// composable идемпотентно: повторные вызовы из ChatPage/MainHeader не
// открывают дубль WS-канала и не дублируют HTTP warm-up — субscribers
// просто увеличиваются.
useSupportUnread()
</script>

<style>
html {
    scrollbar-gutter: stable;
}

body {
    overflow-y: scroll;
}
</style>
